import useAxios from "../../utility/axios-token-manager/init";
import { loadStart, loadStop } from "./loading";

export const getUserProfile = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/sales-agent/my-profile");
    dispatch(loadStop());
    const { success, profile, merchants } = response.data;
    if (success === true) {
      return dispatch({
        type: "SET_PROFILE",
        payload: { profile, merchants },
      });
    } else {
      return dispatch({
        type: "SET_PROFILE",
        payload: {},
      });
    }
  } catch (error) {
    dispatch(loadStop());
    return dispatch({
      type: "SET_PROFILE",
      payload: {},
    });
  }
};
export const getAgents = (sector) => async (dispatch) => {
  dispatch(loadStart());
  const getURL = sector
    ? "/excite/agent/get-all/ext04"
    : "/excite/agent/get-all";
  try {
    const response = await useAxios.get(getURL);
    if (response.data.code === 200) {
      dispatch(loadStop());
      return dispatch({
        type: "SET_ALL",
        payload: {
          agents: response.data.agents,
          feedbacks: response.data.feedbacks,
        },
      });
    } else {
      dispatch(loadStop());
      return dispatch({
        type: "SET_ALL",
        payload: { agents: [], feedbacks: [] },
      });
    }
  } catch (error) {
    dispatch(loadStop());
    return dispatch({
      type: "SET_ALL",
      payload: { agents: [], feedbacks: [] },
    });
  }
};

export const getMerchants = (page, limit, headers) => async (dispatch) => {
  dispatch(loadStart());
  // const getURL = `/auth/merchants/${page}/${limit}`
  const getURL = `/auth/merchants/1/30`;
  try {
    const response = await useAxios.get(getURL, { headers });
    dispatch(loadStop());
    const { success, merchants, message } = response.data;
    if (success === true) {
      return dispatch({
        type: "MERCH_ALL",
        payload: { merchants: merchants, message: message, success: success },
      });
    } else {
      return dispatch({
        type: "MERCH_ALL",
        payload: { merchants: [], message: message, success: success },
      });
    }
  } catch (error) {
    dispatch(loadStop());
    return dispatch({
      type: "MERCH_ALL",
      payload: { merchants: [], message: error.message, success: false },
    });
  }
};

export const setUpdate = (data) => {
  return {
    type: "SET_UPDATE",
    payload: data,
  };
};
export const makeFeedBack = (data) => {
  return {
    type: "MAKE_FEEDBACK",
    payload: data,
  };
};

// Ext Admin actions
export const getExtAdminDashboard = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/ext-admin/dashboard");
    dispatch(loadStop());
    if (response.data.success) {
      return dispatch({ type: "EXT_ADMIN_DASHBOARD", payload: response.data.data });
    }
    return dispatch({ type: "EXT_ADMIN_DASHBOARD", payload: null });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "EXT_ADMIN_DASHBOARD", payload: null });
  }
};

export const getExtAdminAgents = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/ext-admin/agents");
    dispatch(loadStop());
    if (response.data.success) {
      return dispatch({
        type: "EXT_ADMIN_AGENTS",
        payload: { agents: response.data.agents, feedbacks: response.data.feedbacks },
      });
    }
    return dispatch({ type: "EXT_ADMIN_AGENTS", payload: { agents: [], feedbacks: [] } });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "EXT_ADMIN_AGENTS", payload: { agents: [], feedbacks: [] } });
  }
};

export const getExtAdminMerchants = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/ext-admin/merchants");
    dispatch(loadStop());
    if (response.data.success) {
      return dispatch({
        type: "EXT_ADMIN_MERCHANTS",
        payload: { merchants: response.data.merchants, payments: response.data.payments, totalCommission: response.data.totalCommission },
      });
    }
    return dispatch({ type: "EXT_ADMIN_MERCHANTS", payload: { merchants: [], payments: [], totalCommission: 0 } });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "EXT_ADMIN_MERCHANTS", payload: { merchants: [], payments: [], totalCommission: 0 } });
  }
};

export const getExtAdminFeedbacks = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/ext-admin/feedbacks");
    dispatch(loadStop());
    if (response.data.success) {
      return dispatch({ type: "EXT_ADMIN_FEEDBACKS", payload: response.data.feedbacks });
    }
    return dispatch({ type: "EXT_ADMIN_FEEDBACKS", payload: [] });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "EXT_ADMIN_FEEDBACKS", payload: [] });
  }
};

export const createExtAgent = (agentData) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.post("/ext-admin/agents/create", agentData);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

export const approveExtAgent = (id, state) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/ext-admin/agents/${id}/approve`, { state });
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

export const assignExtAgentSector = (id, sector) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/ext-admin/agents/${id}/sector`, { sector });
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

export const getExtAgentDetail = (id) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get(`/ext-admin/agents/${id}`);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

export const updateExtAdminProfile = (data) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put("/ext-admin/profile", data);
    dispatch(loadStop());
    if (response.data.success) {
      dispatch({ type: "EXT_ADMIN_PROFILE", payload: response.data.profile });
    }
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

export const changeExtAdminPassword = (data) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put("/ext-admin/change-password", data);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

export const getExtAdminProfile = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/ext-admin/profile");
    dispatch(loadStop());
    if (response.data.success) {
      dispatch({ type: "EXT_ADMIN_PROFILE", payload: response.data.profile });
    }
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

// ─── Global admin actions ────────────────────────────────────────────────────

export const getGlobalDashboard = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/ext-admin/global/dashboard");
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "GLOBAL_DASHBOARD", payload: response.data.data });
    return dispatch({ type: "GLOBAL_DASHBOARD", payload: null });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "GLOBAL_DASHBOARD", payload: null });
  }
};

export const getGlobalAgents = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/ext-admin/global/agents");
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "GLOBAL_AGENTS", payload: response.data.agents });
    return dispatch({ type: "GLOBAL_AGENTS", payload: [] });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "GLOBAL_AGENTS", payload: [] });
  }
};

export const getGlobalAgentDetail = (id) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get(`/ext-admin/global/agents/${id}`);
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "GLOBAL_AGENT_DETAIL", payload: response.data });
    return dispatch({ type: "GLOBAL_AGENT_DETAIL", payload: null });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "GLOBAL_AGENT_DETAIL", payload: null });
  }
};

export const getGlobalMerchants = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/ext-admin/global/merchants");
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "GLOBAL_MERCHANTS", payload: response.data.merchants });
    return dispatch({ type: "GLOBAL_MERCHANTS", payload: [] });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "GLOBAL_MERCHANTS", payload: [] });
  }
};

export const getGlobalSalesAdmins = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/ext-admin/global/sales-admins");
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "GLOBAL_SALES_ADMINS", payload: response.data.admins });
    return dispatch({ type: "GLOBAL_SALES_ADMINS", payload: [] });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "GLOBAL_SALES_ADMINS", payload: [] });
  }
};

export const getGlobalWallets = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/ext-admin/global/wallets");
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "GLOBAL_WALLETS", payload: response.data.wallets });
    return dispatch({ type: "GLOBAL_WALLETS", payload: [] });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "GLOBAL_WALLETS", payload: [] });
  }
};

export const getGlobalFeedbacks = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/ext-admin/global/feedbacks");
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "GLOBAL_FEEDBACKS", payload: response.data.feedbacks });
    return dispatch({ type: "GLOBAL_FEEDBACKS", payload: [] });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "GLOBAL_FEEDBACKS", payload: [] });
  }
};

// ─── Super admin actions (EXMANAF — hits /admin/global/*) ────────────────────

export const getSuperDashboard = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/admin/global/dashboard");
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "SUPER_DASHBOARD", payload: response.data.data });
    return dispatch({ type: "SUPER_DASHBOARD", payload: null });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "SUPER_DASHBOARD", payload: null });
  }
};

export const getSuperAgents = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/admin/global/agents");
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "SUPER_AGENTS", payload: response.data.agents });
    return dispatch({ type: "SUPER_AGENTS", payload: [] });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "SUPER_AGENTS", payload: [] });
  }
};

export const getSuperAgentDetail = (id) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/admin/global/agents/" + id);
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "SUPER_AGENT_DETAIL", payload: response.data });
    return dispatch({ type: "SUPER_AGENT_DETAIL", payload: null });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "SUPER_AGENT_DETAIL", payload: null });
  }
};

export const approveSuperAgent = (id, state) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/admin/global/agents/${id}/approve`, { state });
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

export const getSuperMerchants = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/admin/global/merchants");
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "SUPER_MERCHANTS", payload: response.data.merchants });
    return dispatch({ type: "SUPER_MERCHANTS", payload: [] });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "SUPER_MERCHANTS", payload: [] });
  }
};

export const getSuperSalesAdmins = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/admin/global/sales-admins");
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "SUPER_SALES_ADMINS", payload: response.data.admins });
    return dispatch({ type: "SUPER_SALES_ADMINS", payload: [] });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "SUPER_SALES_ADMINS", payload: [] });
  }
};

export const getSuperSalesAdminDetail = (id) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get(`/admin/global/sales-admins/${id}`);
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "SUPER_SALES_ADMIN_DETAIL", payload: response.data });
    return dispatch({ type: "SUPER_SALES_ADMIN_DETAIL", payload: null });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "SUPER_SALES_ADMIN_DETAIL", payload: null });
  }
};

export const getSuperWallets = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/admin/global/wallets");
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "SUPER_WALLETS", payload: response.data.wallets });
    return dispatch({ type: "SUPER_WALLETS", payload: [] });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "SUPER_WALLETS", payload: [] });
  }
};

export const getSuperFeedbacks = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/admin/global/feedbacks");
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "SUPER_FEEDBACKS", payload: response.data.feedbacks });
    return dispatch({ type: "SUPER_FEEDBACKS", payload: [] });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "SUPER_FEEDBACKS", payload: [] });
  }
};

// ─── Super admin sector actions ───────────────────────────────────────────────

export const getSuperSectors = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/admin/global/sectors");
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "SUPER_SECTORS", payload: response.data.sectors });
    return dispatch({ type: "SUPER_SECTORS", payload: [] });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "SUPER_SECTORS", payload: [] });
  }
};

export const createSuperSector = (data) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.post("/admin/global/sectors", data);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

export const updateSuperSector = (id, data) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/admin/global/sectors/${id}`, data);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

export const deleteSuperSector = (id) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.delete(`/admin/global/sectors/${id}`);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

export const assignSuperAgentSector = (agentId, sectorId) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/admin/global/agents/${agentId}/sector`, { sectorId });
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

// ─── Ext-admin sector actions ─────────────────────────────────────────────────

export const getExtSectors = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/ext-admin/sectors");
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "EXT_SECTORS", payload: response.data.sectors });
    return dispatch({ type: "EXT_SECTORS", payload: [] });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "EXT_SECTORS", payload: [] });
  }
};

export const createExtAdminSector = (data) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.post("/ext-admin/sectors", data);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

export const updateExtAdminSector = (id, data) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/ext-admin/sectors/${id}`, data);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

export const deleteExtAdminSector = (id) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.delete(`/ext-admin/sectors/${id}`);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

export const assignExtAgentSectorRef = (agentId, sectorId) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/ext-admin/agents/${agentId}/sector-ref`, { sectorId });
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

// ─── Admin Payments (Paystack) ────────────────────────────────────────────────

export const getAdminPaymentsOverview = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/admin/payments/overview");
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "ADMIN_PAYMENTS_OVERVIEW", payload: response.data.data });
    return dispatch({ type: "ADMIN_PAYMENTS_OVERVIEW", payload: null });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "ADMIN_PAYMENTS_OVERVIEW", payload: null });
  }
};

export const getAdminTransactions = (params = {}) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const qs = new URLSearchParams(params).toString();
    const response = await useAxios.get(`/admin/payments/transactions${qs ? "?" + qs : ""}`);
    dispatch(loadStop());
    if (response.data.success)
      return dispatch({ type: "ADMIN_TRANSACTIONS", payload: { data: response.data.data, meta: response.data.meta } });
    return dispatch({ type: "ADMIN_TRANSACTIONS", payload: { data: [], meta: {} } });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "ADMIN_TRANSACTIONS", payload: { data: [], meta: {} } });
  }
};

export const getAdminTransactionDetail = (id) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get(`/admin/payments/transactions/${id}`);
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "ADMIN_TX_DETAIL", payload: response.data.data });
    return dispatch({ type: "ADMIN_TX_DETAIL", payload: null });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "ADMIN_TX_DETAIL", payload: null });
  }
};

export const getAdminSettlements = (params = {}) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const qs = new URLSearchParams(params).toString();
    const response = await useAxios.get(`/admin/payments/settlements${qs ? "?" + qs : ""}`);
    dispatch(loadStop());
    if (response.data.success)
      return dispatch({ type: "ADMIN_SETTLEMENTS", payload: { data: response.data.data, meta: response.data.meta } });
    return dispatch({ type: "ADMIN_SETTLEMENTS", payload: { data: [], meta: {} } });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "ADMIN_SETTLEMENTS", payload: { data: [], meta: {} } });
  }
};

export const getAdminDisputes = (params = {}) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const qs = new URLSearchParams(params).toString();
    const response = await useAxios.get(`/admin/payments/disputes${qs ? "?" + qs : ""}`);
    dispatch(loadStop());
    if (response.data.success)
      return dispatch({ type: "ADMIN_DISPUTES", payload: { data: response.data.data, meta: response.data.meta } });
    return dispatch({ type: "ADMIN_DISPUTES", payload: { data: [], meta: {} } });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "ADMIN_DISPUTES", payload: { data: [], meta: {} } });
  }
};

export const getAdminRefunds = (params = {}) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const qs = new URLSearchParams(params).toString();
    const response = await useAxios.get(`/admin/payments/refunds${qs ? "?" + qs : ""}`);
    dispatch(loadStop());
    if (response.data.success)
      return dispatch({ type: "ADMIN_REFUNDS", payload: { data: response.data.data, meta: response.data.meta } });
    return dispatch({ type: "ADMIN_REFUNDS", payload: { data: [], meta: {} } });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "ADMIN_REFUNDS", payload: { data: [], meta: {} } });
  }
};

export const createAdminRefund = (body) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.post("/admin/payments/refund", body);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.response?.data?.message || error.message };
  }
};

export const getAdminWalletDetail = (userId) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get(`/admin/wallets/${userId}`);
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "ADMIN_WALLET_DETAIL", payload: response.data.data });
    return dispatch({ type: "ADMIN_WALLET_DETAIL", payload: null });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "ADMIN_WALLET_DETAIL", payload: null });
  }
};

export const toggleAdminWallet = (userId) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/admin/wallets/${userId}/toggle`);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

// ─── Admin SeerBit Wallets & Compliance ────────────────────────────────────────

export const getSeerbitWallets = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/admin/seerbit/wallets");
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "SEERBIT_WALLETS", payload: response.data.wallets });
    return dispatch({ type: "SEERBIT_WALLETS", payload: [] });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "SEERBIT_WALLETS", payload: [] });
  }
};

export const getSeerbitWalletDetail = (userId) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get(`/admin/seerbit/wallets/${userId}`);
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "SEERBIT_WALLET_DETAIL", payload: response.data.data });
    return dispatch({ type: "SEERBIT_WALLET_DETAIL", payload: null });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "SEERBIT_WALLET_DETAIL", payload: null });
  }
};

export const toggleSeerbitWallet = (userId) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/admin/seerbit/wallets/${userId}/toggle`);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

export const setSeerbitWalletFreeze = (userId, frozen, reason) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/admin/seerbit/wallets/${userId}/freeze`, { frozen, reason });
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.response?.data?.message || error.message };
  }
};

export const setSeerbitMerchantAccount = (userId, body) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/admin/seerbit/wallets/${userId}/merchant-account`, body);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.response?.data?.message || error.message };
  }
};

export const removeSeerbitMerchantAccount = (userId) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.delete(`/admin/seerbit/wallets/${userId}/merchant-account`);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.response?.data?.message || error.message };
  }
};

// Tier limits + fee settings. Amounts are kobo on the wire.
export const getSeerbitSettings = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/admin/seerbit/settings");
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.response?.data?.message || error.message };
  }
};

export const updateSeerbitSettings = (body) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put("/admin/seerbit/settings", body);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.response?.data?.message || error.message };
  }
};

export const getSeerbitFees = ({ from, to, groupBy = "day" } = {}) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const params = new URLSearchParams({ groupBy });
    if (from) params.set("from", from);
    if (to) params.set("to", to);
    const response = await useAxios.get(`/admin/seerbit/fees?${params.toString()}`);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.response?.data?.message || error.message };
  }
};

export const getTierUpgradeRequests = (status = "pending") => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get(`/admin/seerbit/tier-requests?status=${status}`);
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "TIER_UPGRADE_REQUESTS", payload: response.data.data });
    return dispatch({ type: "TIER_UPGRADE_REQUESTS", payload: [] });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "TIER_UPGRADE_REQUESTS", payload: [] });
  }
};

export const reviewTierUpgrade = (userId, action, reason) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/admin/seerbit/tier-requests/${userId}/review`, { action, reason });
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.response?.data?.message || error.message };
  }
};

export const getBusinessUpgradeRequests = (status = "pending") => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get(`/admin/seerbit/business-requests?status=${status}`);
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "BUSINESS_UPGRADE_REQUESTS", payload: response.data.data });
    return dispatch({ type: "BUSINESS_UPGRADE_REQUESTS", payload: [] });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "BUSINESS_UPGRADE_REQUESTS", payload: [] });
  }
};

export const reviewBusinessUpgrade = (userId, action, reason) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/admin/seerbit/business-requests/${userId}/review`, { action, reason });
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.response?.data?.message || error.message };
  }
};

export const getPosRequests = (status = "requested") => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get(`/admin/seerbit/pos-requests?status=${status}`);
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "POS_REQUESTS", payload: response.data.data });
    return dispatch({ type: "POS_REQUESTS", payload: [] });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "POS_REQUESTS", payload: [] });
  }
};

export const connectPosTerminalAdmin = (userId, requestId, body) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/admin/seerbit/pos-requests/${userId}/${requestId}/connect`, body);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.response?.data?.message || error.message };
  }
};

export const reviewPosRequest = (userId, requestId, action, reason, adminNote) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/admin/seerbit/pos-requests/${userId}/${requestId}/review`, {
      action,
      reason,
      adminNote,
    });
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.response?.data?.message || error.message };
  }
};

// ─── Admin Subscription Plans ─────────────────────────────────────────────────

export const getAdminSubPlans = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/admin/subscriptions/plans");
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "ADMIN_SUB_PLANS", payload: response.data.data });
    return dispatch({ type: "ADMIN_SUB_PLANS", payload: [] });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "ADMIN_SUB_PLANS", payload: [] });
  }
};

export const createAdminSubPlan = (body) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.post("/admin/subscriptions/plans", body);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

export const updateAdminSubPlan = (id, body) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/admin/subscriptions/plans/${id}`, body);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

export const toggleAdminSubPlan = (id) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/admin/subscriptions/plans/${id}/toggle`);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

export const getAdminMerchantSubs = (params = {}) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const qs = new URLSearchParams(params).toString();
    const response = await useAxios.get(`/admin/subscriptions/merchants${qs ? "?" + qs : ""}`);
    dispatch(loadStop());
    if (response.data.success)
      return dispatch({ type: "ADMIN_MERCHANT_SUBS", payload: { data: response.data.data, meta: response.data.meta } });
    return dispatch({ type: "ADMIN_MERCHANT_SUBS", payload: { data: [], meta: {} } });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "ADMIN_MERCHANT_SUBS", payload: { data: [], meta: {} } });
  }
};

export const updateAdminMerchantSub = (id, body) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/admin/subscriptions/merchants/${id}`, body);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

export const getAdminSubPayments = (params = {}) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const qs = new URLSearchParams(params).toString();
    const response = await useAxios.get(`/admin/subscriptions/payments${qs ? "?" + qs : ""}`);
    dispatch(loadStop());
    if (response.data.success)
      return dispatch({ type: "ADMIN_SUB_PAYMENTS", payload: { data: response.data.data, meta: response.data.meta } });
    return dispatch({ type: "ADMIN_SUB_PAYMENTS", payload: { data: [], meta: {} } });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "ADMIN_SUB_PAYMENTS", payload: { data: [], meta: {} } });
  }
};

// ─── Platform Earnings ────────────────────────────────────────────────────────

export const getAdminEarnings = (params = {}) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const qs = new URLSearchParams(params).toString();
    const response = await useAxios.get(`/admin/earnings${qs ? "?" + qs : ""}`);
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "ADMIN_EARNINGS", payload: response.data.data });
    return dispatch({ type: "ADMIN_EARNINGS", payload: null });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "ADMIN_EARNINGS", payload: null });
  }
};

// ─── Admin Payout Management ──────────────────────────────────────────────────

export const getAdminPayouts = (params = {}) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const qs = new URLSearchParams(params).toString();
    const response = await useAxios.get(`/admin/payouts${qs ? "?" + qs : ""}`);
    dispatch(loadStop());
    if (response.data.success)
      return dispatch({ type: "ADMIN_PAYOUTS", payload: { data: response.data.data, meta: response.data.meta } });
    return dispatch({ type: "ADMIN_PAYOUTS", payload: { data: [], meta: {} } });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "ADMIN_PAYOUTS", payload: { data: [], meta: {} } });
  }
};

export const getAdminAgentPayoutDetail = (agentId) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get(`/admin/payouts/agent/${agentId}`);
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "ADMIN_AGENT_PAYOUT_DETAIL", payload: response.data.data });
    return dispatch({ type: "ADMIN_AGENT_PAYOUT_DETAIL", payload: null });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "ADMIN_AGENT_PAYOUT_DETAIL", payload: null });
  }
};

export const approveAdminPayout = (id, body) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/admin/payouts/${id}/approve`, body);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.response?.data?.message || error.message };
  }
};

export const rejectAdminPayout = (id, body) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/admin/payouts/${id}/reject`, body);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.response?.data?.message || error.message };
  }
};

export const markAdminPayoutPaid = (id) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.put(`/admin/payouts/${id}/mark-paid`);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.message };
  }
};

// ─── Agent Commission / Payout (agent-facing) ─────────────────────────────────

export const getMyCommissionBalance = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/payouts/balance");
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "AGENT_COMMISSION_BALANCE", payload: response.data.data });
    return dispatch({ type: "AGENT_COMMISSION_BALANCE", payload: null });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "AGENT_COMMISSION_BALANCE", payload: null });
  }
};

export const getMyPayouts = () => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.get("/payouts/my");
    dispatch(loadStop());
    if (response.data.success) return dispatch({ type: "AGENT_PAYOUTS", payload: response.data.data });
    return dispatch({ type: "AGENT_PAYOUTS", payload: [] });
  } catch (error) {
    dispatch(loadStop());
    return dispatch({ type: "AGENT_PAYOUTS", payload: [] });
  }
};

export const requestMyPayout = (body) => async (dispatch) => {
  dispatch(loadStart());
  try {
    const response = await useAxios.post("/payouts/request", body);
    dispatch(loadStop());
    return response.data;
  } catch (error) {
    dispatch(loadStop());
    return { success: false, message: error.response?.data?.message || error.message };
  }
};
